import React from 'react';
import { Icon } from '../icons';

/**
 * Steps — a wizard / progress indicator.
 *
 * Props:
 *   steps: Array<{ id, label, description? }>
 *   current: number                 — index of the active step
 *   onStepClick(index)              — makes completed steps clickable
 *   orientation: 'horizontal' | 'vertical'
 */
const Steps = ({ steps = [], current = 0, onStepClick, orientation = 'horizontal', className = '' }) => (
  <ol className={`ps-steps ps-steps--${orientation} ${className}`.trim()}>
    {steps.map((step, i) => {
      const state = i < current ? 'complete' : i === current ? 'current' : 'upcoming';
      const clickable = onStepClick && i <= current;
      return (
        <li key={step.id ?? i} className={`ps-steps__item is-${state}`} aria-current={state === 'current' ? 'step' : undefined}>
          <button
            type="button"
            className="ps-steps__btn"
            disabled={!clickable}
            onClick={clickable ? () => onStepClick(i) : undefined}
          >
            <span className="ps-steps__marker">
              {state === 'complete' ? <Icon.Check size={15} /> : i + 1}
            </span>
            <span className="ps-steps__text">
              <span className="ps-steps__label">{step.label}</span>
              {step.description && <span className="ps-steps__desc">{step.description}</span>}
            </span>
          </button>
          {i < steps.length - 1 && <span className="ps-steps__connector" aria-hidden="true" />}
        </li>
      );
    })}
  </ol>
);

export default Steps;
